"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Particles } from "../components/magicui/particles";

export function ParticlesDemo() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setMounted(true);

    const mobile =
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    setIsMobile(mobile);
  }, []);

  if (!mounted) return null;

  return (
    <>
      {resolvedTheme === "dark" && (
        <Particles
          className="fixed inset-0 z-[-1] pointer-events-none"
          quantity={isMobile ? 25 : 150}
          ease={30}
          color={"#fff"}
          size={1}
          refresh
        />
      )}
    </>
  );
}
